// extracted by mini-css-extract-plugin
module.exports = {"container":"container--DemoTimelinePosts-DemoSpaceTimeline-DemoSpace-routes__1KtEP"};